module.exports = __webpack_public_path__ + "img/mapa_mesas.c0445906.png";